<template>
	<div class="content-wrapper">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-home"></i>
						Dashboard
					</a>
				</li>
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-cogs"></i>
						Configuration
					</a>
				</li>
				<li class="breadcrumb-item active">Role</li>
			</ol>
		</nav>
		<section class="content">
			<div class="container-fluid">
				<div class="row justify-content-md-center">
					<div class="col-sm-4">
						<form class="card" @submit.prevent="submitForm()">
							<div class="card-header">
								<h3 class="card-title" v-if="status">New Role</h3>
								<h3 class="card-title" v-else>Update Role</h3>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-sm-12">
										<div class="form-group">
											<label for="role">Role *</label>
											<input type="text" class="form-control form-control-sm"
												:class="{ 'is-invalid': errors.role }" placeholder="Role"
												v-model="role.role" />
											<span v-if="errors.role" class="invalid-feedback">{{ errors.role[0]
											}}</span>
										</div>
									</div>
									<div class="col-sm-12">
										<div class="form-group">
											<label for="order">Order *</label>
											<input type="number" min="0" class="form-control form-control-sm"
												:class="{ 'is-invalid': errors.order }" placeholder="Order"
												v-model.number="role.order" />
											<span v-if="errors.order" class="invalid-feedback">{{ errors.order[0]
											}}</span>
										</div>
									</div>
									<div class="col-sm-12">
										<div class="form-group">
											<label for="role_type">Role Type *</label>
											<select class="form-control form-control-sm"
												:class="{ 'is-invalid': errors.role_type }" placeholder="Role_type"
												v-model="role.role_type">
												<option value="">Select Role Type</option>
												<option>Admin</option>
												<option>Manager</option>
												<option>Dealer</option>
												<option>Security</option>
												<option>GRE</option>
												<option>TD</option>
											</select>
											<span v-if="errors.role_type" class="invalid-feedback">{{
												errors.role_type[0] }}</span>
										</div>
									</div>
									<div class="col-sm-12">
										<div class="form-group">
											<label for="description">Description</label>
											<textarea type="text" class="form-control form-control-sm"
												:class="{ 'is-invalid': errors.description }" placeholder="Description"
												v-model="role.description"></textarea>
											<span v-if="errors.description" class="invalid-feedback">{{
												errors.description[0] }}</span>
										</div>
									</div>
								</div>
							</div>
							<div class="card-footer">
								<div class="float-right">
									<button class="btn btn-sm btn-outline-danger" type="button" @click="discard()"><i
											class="fas fa-ban"></i> Discard</button>
									<button class="btn btn-sm btn-outline-success" type="submit">
										<span v-if="status"> <i class="fas fa-save"></i> Submit </span>
										<span v-else> <i class="fas fa-save"></i> Update </span>
									</button>
								</div>
							</div>
						</form>
					</div>
					<div class="col-sm-8">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">Roles</h3>
								<div class="card-tools">
									<div
										class="custom-control custom-switch custom-switch-off-success custom-switch-on-danger">
										<input type="checkbox" class="custom-control-input" id="trashed"
											v-model="meta.trashed" @click="isTrashed" />
										<label class="custom-control-label" for="trashed">Trashed</label>
									</div>
								</div>
							</div>
							<div class="card-body">
								<div class="form-group">
									<input class="form-control form-control-sm" type="text" placeholder="Search"
										v-model="meta.search" @keyup="search" v-if="!meta.trashed" />
								</div>
								<table class="table table-responsive-sm table-bordered table-striped table-sm">
									<thead>
										<tr>
											<th class="text-center">#</th>
											<Thead :fieldName="'order'" :placeholder="'Order'" :keyword="meta.keyword"
												:orderBy="meta.order_by" @sort_fun="sort"></Thead>
											<Thead :fieldName="'role'" :placeholder="'Role'" :keyword="meta.keyword"
												:orderBy="meta.order_by" @sort_fun="sort"></Thead>
											<Thead :fieldName="'role_type'" :placeholder="'Role Type'"
												:keyword="meta.keyword" :orderBy="meta.order_by" @sort_fun="sort">
											</Thead>
											<Thead :fieldName="'description'" :placeholder="'Description'"
												:keyword="meta.keyword" :orderBy="meta.order_by" @sort_fun="sort">
											</Thead>
											<th class="text-center">Action</th>
											<!-- <th class="text-center">#</th>
                                            <th @click="sort('role')">
                                                Role
                                                <span>
                                                    <i v-if="meta.keyword=='role' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='role' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('role_type')">
                                                Role Type
                                                <span>
                                                    <i v-if="meta.keyword=='role_type' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='role_type' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('description')">
                                                Description
                                                <span>
                                                    <i v-if="meta.keyword=='description' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='description' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th class="text-center">Action</th> -->
										</tr>
									</thead>
									<tbody>
										<tr v-for="(role, key) in roles" :key="key">
											<td class="text-center">{{ meta.from + key }}</td>
											<td class="text-center">{{ role.order }}</td>
											<td>{{ role.role }}</td>
											<td>{{ role.role_type }}</td>
											<td>{{ role.description }}</td>
											<td class="text-center" v-if="!meta.trashed">
												<button class="btn btn-xs btn-outline-success" data-toggle="tooltip"
													data-placement="bottom" title="Edit">
													<i class="fas fa-pencil-alt" @click="edit(role)"></i>
												</button>
												<button class="btn btn-xs btn-outline-danger" data-toggle="tooltip"
													data-placement="bottom" title="Delete" @click="deleteRole(role)">
													<i class="fas fa-trash-alt"></i>
												</button>
											</td>
											<td class="text-center" v-else>
												<button class="btn btn-xs btn-outline-success" data-toggle="tooltip"
													data-placement="bottom" title="Restore" @click="deleteRole(role)">
													<i class="fas fa-trash-restore"></i>
												</button>
											</td>
										</tr>
										<tr v-if="roles.length <= 0">
											<td colspan="20" style="text-align: center;">No Records Found</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="card-footer">
								<div class="float-right">
									<Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage"
										:currentPage="meta.page" @pagechanged="onPageChange" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import Thead from "@/components/Thead.vue";
export default {
	name: "Role",
	components: { Pagination, Thead },
	data() {
		return {
			status: true,
			meta: {
				search: "",
				order_by: "asc",
				keyword: "order",
				per_page: 10,
				totalRows: 0,
				page: 1,
				lastPage: 1,
				from: 1,
				maxPage: 1,
				trashed: false,
			},
			role: {
				role_id: "",
				role: "",
				role_type: "",
				order: 0,
				description: "",
			},
			roles: [],
			errors: []
		};
	},
	mounted() {
		let vm = this;
		vm.index();
	},

	methods: {
		submitForm() {
			let vm = this;
			if (vm.status) {
				vm.create();
			} else {
				vm.update();
			}
		},

		edit(role) {
			let vm = this;
			(vm.status = false), (vm.role = role), vm.$refs.role.focus();
		},

		index() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "paginateRoles", data: vm.meta })
				.then(function (response) {
					vm.roles = response.data.data;
					vm.meta.totalRows = response.data.meta.total;
					vm.meta.lastPage = response.data.meta.last_page;
					vm.meta.from = response.data.meta.from;
					vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		isTrashed() {
			let vm = this;
			vm.meta.trashed = !vm.meta.trashed;
			if (vm.meta.trashed) vm.meta.page = 1;
			vm.index();
		},

		search() {
			let vm = this;
			vm.meta.page = 1;
			vm.index();
		},
		sort(field) {
			console.log("field", field)
			this.meta.keyword = field;
			this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
			this.index();
		},
		create() {
			let vm = this;
			let loader = vm.$loading.show();
			let uri = { uri: "addRole", data: vm.role };
			vm.$store
				.dispatch("post", uri)
				.then(function () {
					loader.hide();
					vm.$store.dispatch("success", "Role is successfully created");
					vm.discard();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		discard() {
			let vm = this;
			vm.role.role = "";
			vm.role.role_type = "";
			vm.role.order = 0;
			vm.role.description = "";
			vm.errors = [];
			vm.status = true;
			vm.index();
		},

		update() {
			let vm = this;
			let loader = vm.$loading.show();
			let uri = { uri: "updateRole", data: vm.role };
			vm.$store
				.dispatch("post", uri)
				.then(function () {
					loader.hide();
					vm.$store.dispatch("success", "Role is successfully updated");
					vm.discard();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		deleteRole(role) {
			if (confirm("Do you want to continue... ?")) {
				let vm = this;
				let loader = vm.$loading.show();
				let uri = { uri: "deleteRole", data: role };
				vm.$store
					.dispatch("post", uri)
					.then(function () {
						loader.hide();
						vm.$store.dispatch("success", "Role is successfully deleted");
						vm.discard();
					})
					.catch(function (error) {
						loader.hide();
						vm.errors = error.response.data.errors;
						vm.$store.dispatch("error", error.response.data.message);
					});
			}
		},

		onPageChange(page) {
			this.meta.page = page;
			this.index();
		},
	},
};
</script>
